// Company Status

(function ($) {
    "use strict";
    $(window).ready(function () {
        var filter = $('#cat-filter');
        var checkboxes = filter.find('.filter-check');
        var checkedIDs;
        var checkedSlugs;

        if (filter.data('params') == true) {
            var params = getQueryParams('industries');
            var paramsArray = params.industries.split(",");
            var checkedIDs = [];

            var i;

            for (i = 0; i < paramsArray.length; ++i) {
                checkedIDs.push($('.filter-check[data-slug=' + paramsArray[i] + ']').val());
            }

            catReload(checkedIDs);
        }

        checkboxes.change(function () {
            checkedIDs = checked();
            checkedSlugs = checked_slugs();

            modifyUrl(checkedSlugs);
            catReload(checkedIDs);
        });

        function checked() {
            var checked = [];

            $(".filter-check:checked").each(function () {
                checked.push($(this).val());
            });

            return checked;
        }

        function checked_slugs() {
            var checked_slugs = [];

            $(".filter-check:checked").each(function () {
                checked_slugs.push($(this).data('slug'));
            });

            return checked_slugs;
        }

        function modifyUrl(paramValues) {
            var url = window.location.href;
            var params = getQueryParams('industries');
            var size = params.olength;

            if (typeof params.industries !== 'undefined') {
                url = removeQueryStringParameter('industries', url, size, params.pos);
            }

            if (size > 1) {
                url = url + '&industries=' + paramValues.join(',');
            } else {
                url = url + '?industries=' + paramValues.join(',');
            }

            window.history.pushState(null, null, url);
        }

        function getQueryParams(searchIndex) {
            var result = {};
            var keys = [];
            var params = window.location.search;

            params = params.substr(1);
            var queryParamArray = params.split('&');

            queryParamArray.forEach(function (queryParam, i) {
                i++;
                var item = queryParam.split("=");
                keys.push(item[0]);
                result[item[0]] = decodeURIComponent(item[1]);

                if (typeof searchIndex !== 'undefined') {
                    if (item[0] === searchIndex) {
                        result['pos'] = i;
                    }
                }
            });

            result['olength'] = keys.length;

            return result;
        }

        // function getUrlParam(name, url) {
        //     var results = new RegExp('[&/?]' + name + '=([^&#]*)').exec(url);

        //     return (results && results[1]) || undefined;
        // }

        function removeQueryStringParameter(name, url, size, pos) {
            if (size === 1) {
                var re = new RegExp('[?]' + name + '=([^&]$|[^&]*)');
            } else if (size > 1 && pos === 1) {
                var re = new RegExp(name + '=([^&]$|[^&]*)&');
            } else if (size > 1 && pos > 1) {
                var re = new RegExp('[&]' + name + '=([^&]$|[^&]*)');
            }

            return url.replace(re, '');
        }

        // function detectQueryString(url) {
        //     var pattern = new RegExp(/\?.+=.*/g);

        //     return pattern.test(url);
        // }

        function catReload(checkedIDs) {
            $('.loader-overlay').css('z-index', '99');
            $('.loader-overlay').css('opacity', '1');

            $.ajax({
                url: ajax_object.ajax_url,
                type: 'POST',
                data: {
                    'checked': checkedIDs,
                    'action': 'category_filter'
                },
                success: function (e) {
                    var parsedObj = JSON.parse(e);

                    console.log(parsedObj);

                    var articles = $('#results-overview .card-wrapper');

                    articles.css('opacity', '0');
                    articles.remove();

                    for (var i = 0; i < parsedObj.length; i++) {
                        var article = parsedObj[i];

                        var imageID = article.image.title;
                        var imageSource = article.image.source;
                        var imageSrcSet = article.image.srcset;
                        var imageSizes = article.image.sizes;
                        var imageAlt = article.image.alt;
                        var imageTitle = article.image.title;

                        var category = article.category;
                        var title = article.title;
                        var date = article.date;

                        var btnLabel = article.button.label;
                        var btnLink = article.button.link;

                        var content = buildHTML(imageID, imageSource, imageSrcSet, imageSizes, imageAlt, imageTitle, category, title, date, btnLabel, btnLink);

                        $('#results-overview .row').append(content);
                    }

                    $('.loader-overlay').css('z-index', '-1');
                    $('.loader-overlay').css('opacity', '0');

                    if ($('.results-wrapper').hasClass('d-none')) {
                        $('.results-wrapper').removeClass('d-none');
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log('error');
                },
            })
        }

        function buildHTML(imageID, imageSource, imageSrcSet, imageSizes, imageAlt, imageTitle, category, title, date, btnLabel, btnLink) {
            var html = [];

            html.push('<div class="card-wrapper article-wrapper col-12 col-md-6 col-lg-4 mb-30 px-md-15 has-shadow">');
            html.push('<div class="card h-100 pb-card-1">');
            html.push('<div class="image-wrapper mb-20">');

            html.push('<img src="' + imageSource + '" srcset="' + imageSrcSet + '" sizes="' + imageSizes + '" alt="' + imageAlt + '" title="' + imageTitle + '" class="single-image">');
            html.push('</div>');

            if(category){
                html.push('<span class="category mb-10 text-left px-15 text-uppercase d-block">'+ category +'</span>');
            }
            
            html.push('<h2 class="title mb-20 text-center text-md-left px-15">' + title + '</h2>');
            html.push('<span class="timestamp text-left px-15 text-uppercase d-block">'+ date +'</span>')

            html.push('<div class="button-group">');
            html.push('<div class="button-container">');
            html.push('<a class="btn btn-primary" href="' + btnLink + '">' + btnLabel + '</a>');
            html.push('</div>');
            html.push('</div>');

            html.push('</div>');
            html.push('</div>');

            return html.join('');
        }
    });

})(jQuery);
